<template>
  <div class="empty-route-container">
    <h1 class="empty-route-text mt-16">No waypoints selected</h1>
    <div class="empty-route-image">
      <img
        src="./../../../../../assets/route-image-black.png"
        height="300px"
        width="300px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyRoute",
};
</script>

<style scoped>
.empty-route-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  height: 100%;
}
.empty-route-text {
  font-size: 24px;
  font-weight: 600;
  color: var(--color-text);
}
</style>